export enum ViewerObjectType {
    PLACEMARK = 'PLACEMARK',
    MODEL = 'MODEL',
    LAYOUT = 'LAYOUT'
}